"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    pictureWrapper: {
        position: 'relative',
        '&:hover div': {
            visibility: 'visible'
        },
        '&:hover img': {
            opacity: 0.8
        }
    },
    picture: {
        width: 100,
        height: 100
    },
    caption: {
        position: 'absolute',
        fontSize: 10,
        color: 'white',
        bottom: 0,
        left: 0,
        right: 0,
        textAlign: 'center',
        visibility: 'hidden',
        backgroundColor: 'rgba(0, 0, 0, 0.3)'
    }
};
//# sourceMappingURL=picture.style.js.map